import { RenderingStatus } from "Enumerations";
import { useRootStore } from "Store/RootStore";

export const useInLoggedInStatus = () => {
    const authStore = useRootStore("AuthStore");
    return authStore.loginStatus === RenderingStatus.Ready;
};
